function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "alert"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M26.0352 0.759766C11.8554 0.759766 0.320312 12.2949 0.320312 26.4747C0.320312 40.6544 11.8554 52.1895 26.0352 52.1895C40.215 52.1895 51.7501 40.6544 51.7501 26.4747C51.7501 12.2949 40.215 0.759766 26.0352 0.759766Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  d: "M28.1781 39.3322C28.1781 40.5156 27.2188 41.475 26.0354 41.475C24.8519 41.475 23.8926 40.5156 23.8926 39.3322C23.8926 38.1488 24.8519 37.1895 26.0354 37.1895C27.2188 37.1895 28.1781 38.1488 28.1781 39.3322Z",
  fill: "#EF3C2E"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  d: "M28.1781 30.7608C28.1781 31.9434 27.2184 32.9036 26.0354 32.9036C24.8523 32.9036 23.8926 31.9434 23.8926 30.7608V13.6174C23.8926 12.4344 24.8523 11.4746 26.0354 11.4746C27.2184 11.4746 28.1781 12.4344 28.1781 13.6174V30.7608Z",
  fill: "#EF3C2E"
}));

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.330cca276a2668ce798f5a62fb0515f1.svg";
export { ForwardRef as ReactComponent };